export default "__VITE_ASSET__4adb2b0b__"